import * as backend from '../backend-helpers/memberBobstoreProductsOwned';

const GET_BPO_REQUEST = 'GET_BPO_REQUEST';
const GET_BPO_SUCCESS = 'GET_BPO_SUCCESS';
const GET_BPO_ERROR = 'GET_BPO_ERROR';

const GET_BPO = 'GET_BPO';


const defaultState = {
    list: [],
    totalCount: null,
    offset: 0,
    isLoading: false
};

export default function bobstoreProductsOwned(state = defaultState, action) {
    switch (action.type) {
        case GET_BPO_REQUEST:
            return {
                ...state,
                isLoading: true,
                list: action.infinite ? state.list : [],
            };
        
        case GET_BPO_SUCCESS:
            const { list, totalCount } = action.result.data;
            let offset, newList;

            if (action.infinite) {
                newList = Array.prototype.concat(state.list, list);
                offset = action.offset + list.length;
            } else {
                newList = list;
                offset = list.length;
            }
    
            return {
                ...state,
                isLoading: false,
                list: newList,
                offset,
                totalCount
            };

        case GET_BPO:
            return {
                ...state,
                list: [ action.bobstoreProducstOwned, ...state.list.slice(0,-1) ]
            };

        default:
            return state;
    }
}

export const getBobstoreProductsOwned = ({infinite = false, ...params}) => ({
    promise: backend.getMemberBobstoreProductsOwned({...params}),
    types: [GET_BPO_REQUEST, GET_BPO_SUCCESS, GET_BPO_ERROR],
    infinite,
    offset: params.offset
});

export const getBobstoreProductsOwnedAction = data => ({
    type: GET_BPO,
    bobstoreProductsOwned: data.bobstoreProductsOwned,
});



// WEBPACK FOOTER //
// ./src/reducers/memberBobstoreProductsOwned.js